// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ps-6";
export var imgContainer = "_ps-3";
export var menuIcon = "_ps-5";
export var pillWrapper = "_ps-2";
export var pillsContainer = "_ps-1";
export var subscriptionCard = "_ps-0";
export var subscriptionLogo = "_ps-4";